var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "default-page-paddings" }, [
    _c(
      "div",
      { staticClass: "container container-medium article" },
      [
        !_vm.inModal
          ? _c("Heading", {
              attrs: {
                title: _vm.$t("terms"),
                routeName: "vignette",
                alignment: "text-left",
              },
            })
          : _vm._e(),
        _c(
          "div",
          { staticClass: "default-content reading" },
          [
            _vm.locale == "ro"
              ? [
                  !_vm.inModal
                    ? [_vm._m(0), _c("p", [_vm._v("Termeni si conditii")])]
                    : _vm._e(),
                  _c("p", { staticClass: "p-small" }, [
                    _vm._v(
                      "Folosirea acestui site implica acceptarea termenilor si conditiilor de mai jos. Recomandam citirea cu atentie a acestora."
                    ),
                  ]),
                  _vm._m(1),
                  _vm._m(2),
                  _vm._m(3),
                  _vm._m(4),
                  _vm._m(5),
                  _c("p", [
                    _vm._v(
                      "Rovinietele se emit numai dupa confirmarea platii sumei in contul bancar al U.N.T.R.R. (in cateva minute in cazul platii online cu cardul bancar finalizate sau imediat ce este confirmata incasarea sumelor de bani aferente in contul UNTRR in cazul platii prin ordin de plata)."
                    ),
                  ]),
                  _vm._m(6),
                  _vm._m(7),
                  _vm._m(8),
                  _c("p", [
                    _vm._v(
                      "Pentru utilizarea sitului e-rovinieta.ro si a serviciilor oferite prin intermediul acestuia este necesar sa va creati un cont. Contul dumneavoastra poate fi folosit si pentru autentificare pe site-ul taxa-pod-fetesti.ro, detinut tot de U.N.T.R.R. Prin inregistrarea unui cont pe site va exprimati consimtamantul cu privire la acest aspect."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Sunteti de acord si acceptati ca, fara nici o notificare prealabila, putem sterge sau adauga orice informatie pe site, intrerupe orice activitate pe site sau arhiva din continutul site-ului, iar in cazul in care se fac referiri la alte site-uri nu garantam si/sau confirmam sub nici o forma tipul de informatie pe care il veti gasi pe aceste site-uri. Ramane la aprecierea dumneavoastra daca vizitati sau nu aceste site-uri sau luati sau nu in considerare informatia gasita pe site-urile respective."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Prin inregistrarea cererii de stergerea contului de pe e-rovinieta.ro va dati acordul si pentru stergerea contului de pe taxa-pod-fetesti.ro"
                    ),
                  ]),
                  _vm._m(9),
                  _c("p", [
                    _vm._v(
                      "U.N.T.R.R. ofera tuturor utilizatorilor accesul limitat, in interes personal, pe site-ul e-rovinieta.ro si nu le confera drepturile de a descarca sau de a modifica partial sau integral site-ul, de a reproduce partial sau integral site-ul, de a copia, de a vinde/ revinde sau de a exploata site-ul in orice alta maniera, in scopuri comerciale sau contrare intereselor U.N.T.R.R., fara acordul prealabil scris al acesteia."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      'Comunicarea cu site-ul www.e-rovinieta.ro - se poate face prin interactiunea cu acesta, postarea opiniilor vizavi de calitatea serviciului oferit se poate face prin comunicarea acestora (opiniilor) la adresele mentionate la sectiunea "contact". Vor fi ignorate pareri sau adresari ce contin injurii sau un limbaj neadecvat. Distribuitorul are libertatea de a gestiona informatiile primite fara a fi nevoit sa aduca justificari pentru aceasta.'
                    ),
                  ]),
                  _vm._m(10),
                  _vm._m(11),
                  _vm._m(12),
                  _vm._m(13),
                  _vm._m(14),
                  _vm._m(15),
                  _vm._m(16),
                  _vm._m(17),
                  _vm._m(18),
                  _vm._m(19),
                  _vm._m(20),
                  _vm._m(21),
                  _vm._m(22),
                  _c("p", [
                    _vm._v(
                      "Prin lansarea unei comenzi electronice pe site-ul www.e-rovinieta.ro, utilizatorul este de acord cu forma de comunicare, prin care distribuitorul isi deruleaza operatiunile de distribuire a rovinietei."
                    ),
                  ]),
                  _vm._m(23),
                  _vm._m(24),
                  _c("p", [
                    _vm._v(
                      "Distribuitorul va considera comanda confirmata ca avand valoarea unui Contract. Contractul astfel incheiat intra in vigoare la confirmarea comenzii de catre utilizator."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Termenii si conditiile generale de vanzare vor sta la baza Contractului astfel incheiat."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Dupa validarea comenzii prin bifarea campurilor: am citit si sunt de acord cu termenii si conditiile si imi asum intreaga responsabilitate pentru datele introduse pentru rovinietele solicitate, utilizatorii nu mai pot reveni asupra acesteia, comanda lansata fiind certa si exigibila, iar plata fiind obligatorie pentru utilizator, daca doreste emiterea rovinietei/ rovinietelor solicitate."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Emiterea rovinietelor se va efectua numai dupa incasarea sumei de plata (intrarea banilor) in contul bancar al U.N.T.R.R., iar data de inceput a valabilitatii rovinietelor nu poate fi anterioara acestei date."
                    ),
                  ]),
                  _c("p", [_vm._v("Rovinieta/rovinietele nu se pot returna.")]),
                  _vm._m(25),
                  _c("p", [
                    _vm._v(
                      "Distribuitorul va emite roviniete conform cu datele comenzii, daca acestea se incadreaza in conditiile de emitere roviniete, dupa confirmarea platii."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Distribuitorul va pune la dispozitia utilizatorului documentul copie-client care atesta emiterea rovinietei, ca anexa la factura ce poate fi descarcata din contul utilizatorului."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "In cazul corectiei numarului de inmatriculare, Distribuitorul va pune la dispozitia utilizatorului documentul copie-client care atesta corectia efectuata."
                    ),
                  ]),
                  _vm._m(26),
                  _c("p", [
                    _vm._v(
                      "Documentele rezultate din procesarea cu succes a comenzii: factura, copia client, si, daca e cazul, documentul de corectie pot fi vizualizate si descarcate de catre utilizator dupa logarea cu contul in care s-a transmis comanda."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Aceste documente vor fi transmise utilizatorului si prin email, iar seria rovinietei emise va fi transmisa utilizatorului si prin SMS, contra cost, la alegerea utilizatorului, cu limitarile specifice acestor canale de comunicare (ex.: adresa de email sa fie specificata corect in profilul utilizatorului pe e-rovinieta.ro, casuta de email sa fie accesibila si sa primeasca emailuri de la domeniul e-rovinieta.ro, numarul de telefon mobil al utilizatorului inregistrat corect in cont si sa poata primi mesaje text; orice depinde de terte parti in aceste canale de comunicare nu este responsabilitatea U.N.T.R.R.)"
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      'Clientul poate fi notificat de catre CNAIR pe email-ul contului daca clientul alege sa fie notificat de expirarea rovinietei pe o perioada de 30 zile, 90 de zile sau 12 luni, prin bifarea "Vreau sa primesc email de la CNAIR inainte de expirare rovinieta".'
                    ),
                  ]),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.$t("sms_notice")) },
                  }),
                  _vm._m(27),
                  _c("p", [
                    _vm._v(
                      "Intregul continut al site-ului E-rovinieta.ro - imagini, texte, simboluri, elemente de grafica web, scripturi, programe si alte date - este proprietatea U.N.T.R.R. si este aparat de Legea privind dreptul de autor şi drepturile conexe, republicata, cu modificari si completări ulterioare și de Legea privind protecţia desenelor şi modelelor – republicata, cu modificarile si completarile ulterioare."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Folosirea fara acordul scris al U.N.T.R.R. a oricaror elemente enumerate mai sus se pedepseste conform legilor in vigoare."
                    ),
                  ]),
                  _vm._m(28),
                  _c("p", [
                    _vm._v(
                      "Toate documentele si informatiile de orice natura furnizate de catre utilizator distribuitorului vor fi utilizate numai pentru executarea contractului sau la cererea autoritatilor statului si pot fi facute cunoscute numai cu consimtamantul scris al distribuitorului si dupa obtinerea unui angajament de confidentialitate din partea celui care le primeste."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Nicio declaratie publica, promovare, comunicat de presa sau orice alt mod de dezvaluire catre terte parti nu va fi facuta de utilizator cu privire la comanda lansata fara consimtamantul prealabil scris al distribuitorului."
                    ),
                  ]),
                  _vm._m(29),
                  _c("p", [
                    _vm._v(
                      "Acceptarea de catre utilizator va fi obligatorie atunci cand rovinietele sunt conforme cu datele si informatiile din comanda. In cazul in care utilizatorul descopera ca rovinietele livrate nu sunt conforme specificatiilor din comanda transmisa, atunci distribuitorul va aduce la indeplinire comanda primita pe cheltuiala lui."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "In cazul in care comanda a fost gresit completata de catre utilizator, responsabilitatea cade in sarcina utilizatorului. Rovinieta/rovinietele nu se pot returna. In momentul transmiterii comenzii aceasta este considerata ca fiind ferma."
                    ),
                  ]),
                  _vm._m(30),
                  _c("p", [
                    _vm._v(
                      "Tariful si modalitatea de plata a tarifului de utilizare a retelei de drumuri sunt specificate in Comanda."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Tariful de utilizare a retelei de drumuri prezentat pe site-ul E-rovinieta.ro include TVA."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Tariful rovinietelor este stabilit in Euro si calculat la cursul BNR din ultima zi lucratoare a lunii anterioare."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Emiterea rovinietei va fi facuta numai dupa confirmarea efectuarii platii (intrarea banilor) in contul U.N.T.R.R."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Plata trebuie sa acopere integral valoarea comenzii, in caz contrar UNTRR nu va emite rovinieta/rovinietele."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "In cazul platilor online efectuate cu card bancar procesatorul de plati electronice poate solicita platitorului informatii suplimentare daca este cazul, inainte de a valida plata si a permite astfel emiterea rovinietei."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Comanda se anuleaza in momenutul in care tranzactia nu este finalizata/accepta de procesatorul de plata PayU."
                    ),
                  ]),
                  _vm._m(31),
                  _c("p", [
                    _vm._v(
                      "Utilizatorul isi asuma responsabilitatea pentru datele furnizate pentru orice comanda transmisa pe site-ul e-rovinieta.ro. Utilizatorul intelege ca nu este suficient sa trimita o comanda de emitere de rovinieta ci trebuie sa astepte confirmarea emiterii rovinietei inainte de a circula pe drumurile nationale."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Distribuitorul nu poate fi responsabil pentru daune de orice fel pe care utilizatorul sau oricare terta parte o poate suferi ca rezultat al indeplinirii de catre distribuitor a oricarei din obligatiile sale conform Comenzii."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "Distribuitorul va fi raspunzator in cazul in care salariatii sai implicati in executarea Comenzii nu indeplinesc oricare din obligatiile ce le revin."
                    ),
                  ]),
                  _vm._m(32),
                  _c("p", [
                    _vm._v(
                      "Nici una din parti nu va fi raspunzatoare pentru neexecutarea obligatiilor sale contractuale, daca o astfel de neexecutare este datorata unui eveniment de forta majora. Forta majora este evenimentul imprevizibil, in afara controlului partilor si care nu poate fi evitat."
                    ),
                  ]),
                  _vm._m(33),
                  _c("p", [
                    _vm._v(
                      "Eventualele litigii aparute intre distribuitor si utilizatori se vor rezolva pe cale amiabila sau, in cazul in care aceasta nu va fi posibila, litigiile vor fi solutionate de instantele judecatoresti romane competente de la sediul distribuitorului."
                    ),
                  ]),
                ]
              : [
                  _c(
                    "div",
                    [
                      !_vm.inModal
                        ? [
                            _vm._m(34),
                            _c("p", [_vm._v("Terms and conditions")]),
                          ]
                        : _vm._e(),
                      _c("p", { staticClass: "p-small" }, [
                        _vm._v(
                          "Use of this site implies acceptance of the terms and conditions below. We recommend reading these carefully."
                        ),
                      ]),
                      _vm._m(35),
                      _c("p", [
                        _vm._v(
                          "The general terms and conditions will apply to all vignettes distributions by U.N.T.R.R., via the website www.e-rovinieta.ro, to the user of the national road network, under the conditions provided by the Methodological Norms for application by CNAIR - S.A. of the usage tariff and of the passage tariff. "
                        ),
                      ]),
                      _vm._m(36),
                      _vm._m(37),
                      _c("p", [
                        _vm._v(
                          "Vignettes are issued only after confirmation of payment of the amount in the bank account of the U.N.T.R.R. (in a few minutes in case of online payment with the completed bank card or as soon as the collection of the related amounts in the UNTRR account is confirmed in case of payment by payment order)."
                        ),
                      ]),
                      _vm._m(38),
                      _vm._m(39),
                      _vm._m(40),
                      _c("p", [
                        _vm._v(
                          "In order to use the e-rovinieta.ro website and the services offered through it, it is necessary to create an account. Your account can also be used for authentication on the website taxa-pod-fetesti.ro, also owned by U.N.T.R.R. By registering an account on the website you express your consent regarding this aspect."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "You consent and agree that, without prior notice, we may delete or add any information on the site, discontinue any activity on the website or archive the content of the site, and if references are made to other sites we do not guarantee and/or we confirm in no way the type of information you will find on these sites. It is up to you to decide whether or not to visit these sites or to take into account or not the information found on those sites."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "By registering the request to delete the account on e-rovinieta.ro you will also give your consent for the deletion of the account on taxa-pod-fetesti.ro "
                        ),
                      ]),
                      _vm._m(41),
                      _c("p", [
                        _vm._v(
                          "U.N.T.R.R. offers all users limited access, in their personal interest, on the e-rovinieta.ro website and does not give them the rights to download or modify partially or completely the site, to reproduce partially or completely the site, to copy, sell/resell or exploit the site in any other manner, for commercial purposes or contrary to the interests of UNTRR, without its prior written consent."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          'Communication with the site www.e-rovinieta.ro - can be done by interacting with it, posting opinions regarding the quality of the service offered can be done by communicating them (opinions) to the addresses mentioned in the "contact" section. Opinions or addresses containing insults or inappropriate language will be ignored. The distributor is free to manage the information received without having to bring justifications for it.'
                        ),
                      ]),
                      _vm._m(42),
                      _vm._m(43),
                      _vm._m(44),
                      _vm._m(45),
                      _vm._m(46),
                      _vm._m(47),
                      _vm._m(48),
                      _vm._m(49),
                      _vm._m(50),
                      _vm._m(51),
                      _vm._m(52),
                      _vm._m(53),
                      _vm._m(54),
                      _vm._m(55),
                      _c("p", [
                        _vm._v(
                          "By launching an electronic order on the website www.e-rovinieta.ro, the user agrees with the form of communication, through which the distributor carries out its operations to distribute the vignette."
                        ),
                      ]),
                      _vm._m(56),
                      _vm._m(57),
                      _c("p", [
                        _vm._v(
                          "The Distributor will consider the order confirmed as having the value of a Contract. The contract thus concluded enters into force upon confirmation of the order by the user."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "The general terms and conditions of sale will be the basis of the Contract thus concluded."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "After validating the order by checking the fields: I have read and agree to the terms and conditions and I assume full responsibility for the data entered for the requested vignettes, users can not return to it, the order is certain and due, and payment is mandatory for the user , if it wishes to issue the requested vignette(s)."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "The issuance of the vignettes will be made only after the collection of the payment amount (money entry) in the bank account of the U.N.T.R.R., and the starting date of the validity of the vignettes cannot be prior to this date."
                        ),
                      ]),
                      _c("p", [_vm._v("The vignette(s) cannot be returned.")]),
                      _vm._m(58),
                      _c("p", [
                        _vm._v(
                          "The distributor will issue vignettes according to the order data, if they meet the conditions of issuing vignettes, after the payment confirmation."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "The distributor will make available to the user the copy-client document attesting the issuance of the bill, as an annex to the invoice that can be downloaded from the user’s account."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "In case of correction of the registration number, the Distributor will make available to the user the copy-client document certifying the correction made. "
                        ),
                      ]),
                      _vm._m(59),
                      _c("p", [
                        _vm._v(
                          "The documents resulting from the successful processing of the order: the invoice, the customer copy, and, if applicable, the correction document can be viewed and downloaded by the user after logging in with the account in which the order was sent."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "These documents will be sent to the user by email, and the series of the issued vignette will be sent to the user by SMS, with a fee, at the user's choice, with the specific limitations of these communication channels (e.g.: the email address to be specified correctly in the user's profile on e-rovinieta.ro, the email box should be accessible and receive emails from the domain e-rovinieta.ro, the mobile phone number of the user correctly registered in the account and be able to receive text messages, anything depends on third parties in these communication channels is not the responsibility of UNTRR) "
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          'The client can be notified by CNAIR by email, on the email of the account if the client chooses to be notified of the expiration of the vignette of 30 days, 90 days or 12 months, by checking "I want to receive an email from CNAIR before expiry".'
                        ),
                      ]),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.$t("sms_notice")) },
                      }),
                      _vm._m(60),
                      _c("p", [
                        _vm._v(
                          "The entire content of the E-rovinieta.ro site - images, texts, symbols, web graphics, scripts, programs and other data - is the property of U.N.T.R.R. and is protected by the Law on Copyright and Related Rights, republished, with subsequent amendments and completions, and by the Law on the Protection of Designs - republished, with subsequent amendments and completions."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "Use without the written consent of the U.N.T.R.R. of any of the elements listed above is punished according to the laws in force."
                        ),
                      ]),
                      _vm._m(61),
                      _c("p", [
                        _vm._v(
                          "All documents and information of any kind provided by the user to the distributor will be used only for the execution of the contract or at the request of state authorities and may be made known only with the written consent of the distributor and after obtaining a confidentiality agreement from the recipient."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "No public statement, promotion, press release or any other form of disclosure to third parties will be made by the user regarding the order placed without the prior written consent of the distributor."
                        ),
                      ]),
                      _vm._m(62),
                      _c("p", [
                        _vm._v(
                          "Acceptance by the user will be mandatory when the vignettes comply with the data and information in the order. If the user discovers that the delivered supplies do not comply with the specifications of the sent order, then the distributor will carry out the order received at his expense."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "If the order has been incorrectly completed by the user, the responsibility falls on the user. The vignette(s) cannot be returned. At the time of sending the order it is considered to be final."
                        ),
                      ]),
                      _vm._m(63),
                      _c("p", [
                        _vm._v(
                          "The tariff and the method of payment of the tariff for the use of the road network are specified in the Order."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "The tariff for using the road network presented on the E-rovinieta.ro website includes VAT."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "The vignette tariff is set in Euro and calculated at the BNR exchange rate from the last working day of the previous month."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "The issuance of the vignette will be made only after the confirmation of the payment (entry of money) in the U.N.T.R.R."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "The payment must fully cover the value of the order, otherwise UNTRR will not issue the vignette(s)."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "In the case of online payments made with a bank card, the electronic payment processor may request additional information from the payer, if applicable, before validating the payment and thus allowing the issuance of the toll. "
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "The order is canceled the moment the transaction is rejected/not accepted on the PayU payment gateway."
                        ),
                      ]),
                      _vm._m(64),
                      _c("p", [
                        _vm._v(
                          "The user assumes responsibility for the data provided for any order submitted on the e-rovinieta.ro website. The user understands that it is not enough to send an order to issue a toll but must wait for confirmation of the issuance of the toll before driving on national roads."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "The Distributor shall not be liable for damages of any kind that the user or any third party may suffer as a result of the Distributor's fulfilment of any of its obligations under the Order."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "The Distributor will be liable if its employees involved in the execution of the Order do not fulfil any of their obligations."
                        ),
                      ]),
                      _vm._m(65),
                      _c("p", [
                        _vm._v(
                          "Neither party will be liable for failure to perform of its contractual obligations if such failure to perform is due to a force majeure event. Force majeure is the unpredictable event, beyond the control of the parties and which cannot be avoided."
                        ),
                      ]),
                      _vm._m(66),
                      _c("p", [
                        _vm._v(
                          "Any disputes between the distributor and users will be resolved amicably or, if this is not possible, the disputes will be resolved by the competent Romanian courts at the distributor's headquarters."
                        ),
                      ]),
                      _c("p"),
                      _c("h2", [_vm._v("Confidentiality")]),
                      _c("p"),
                      _c("p", [
                        _vm._v(
                          "Uniunea Națională a Transportatorilor Rutieri din România (UNTRR) processes your personal data by automated means, the purpose being the record of the delegated and/or authorized persons of UNTRR member companies, issuing vignette, invoicing and registration of payment for products and services provided by UNTRR according your order and your subsequent remote information on the service provided, where applicable."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "You are not obliged to provide the data, as they are necessary for the fulfilment of your order, your refusal makes it impossible to perform the requested service."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "Personal data will only be processed following the agreement received from you."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "The registered information is intended for use by the operator and is communicated only to the following third parties: Romanian National Highways and National Roads Company, for issuing the toll, to the SMS sending service provider (for sending the toll series via SMS, in case of orders registered on the website). On www.e-rovinieta.ro, the online payment processor with the bank card (in the case of online payments with the bank card). The personal data required to make online card payments will be securely transferred to the payment processor."
                        ),
                      ]),
                      _vm._m(67),
                      _vm._m(68),
                      _c("p", [
                        _vm._v(
                          "(1) If personal data concerning a data subject is collected from that data subject, the controller shall, when obtaining such personal data, provide the data subject with all the following information:"
                        ),
                      ]),
                      _vm._m(69),
                      _c("p", [
                        _vm._v(
                          "(2) In addition to the information referred to in paragraph 1, when the personal data are obtained, the controller shall provide the data subject with the following additional information necessary to ensure fair and transparent processing:"
                        ),
                      ]),
                      _vm._m(70),
                      _c("p", [
                        _vm._v(
                          "(3) If the controller intends to further process personal data for a purpose other than that for which they were collected, the controller shall provide the data subject, before such further processing, with information on that secondary purpose and any relevant additional information, in accordance with paragraph (2)."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "(4) Paragraphs (1), (2) and (3) shall not apply if and in so far as the data subject already holds that information."
                        ),
                      ]),
                      _vm._m(71),
                      _vm._m(72),
                      _c("p", [
                        _vm._v(
                          "(1) If personal data have not been obtained from the data subject, the controller shall provide the data subject with the following information.:"
                        ),
                      ]),
                      _vm._m(73),
                      _c("p", [
                        _vm._v(
                          "(2) In addition to the information referred to in paragraph 1, the controller shall provide the data subject with the following information necessary to ensure fair and transparent processing in respect of the data subject:"
                        ),
                      ]),
                      _vm._m(74),
                      _c("p", [
                        _vm._v(
                          "(3) The operator shall provide the information referred to in paragraphs (1) and (2):"
                        ),
                      ]),
                      _vm._m(75),
                      _c("p", [
                        _vm._v(
                          "(4) If the controller intends to further process personal data for a purpose other than that for which they were obtained, the controller shall provide the data subject, before such further processing, with information on that secondary purpose and any relevant additional information, in in accordance with paragraph (2)."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "(5) Paragraphs (1)-(4) do not apply if and to the extent that:"
                        ),
                      ]),
                      _vm._m(76),
                      _vm._m(77),
                      _c("p", [
                        _vm._v(
                          "(1) The data subject has the right to obtain from the controller a confirmation that personal data concerning him or her are being processed or not and, if so, access to those data and to the following information:"
                        ),
                      ]),
                      _vm._m(78),
                      _c("p", [
                        _vm._v(
                          "(2) Where personal data are transferred to a third country or an international organization, the data subject shall have the right to be informed of the appropriate safeguards under Article 46 concerning the transfer."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "(3) The operator shall provide a copy of the personal data subject to processing. For any other copies requested by the data subject, the operator may charge a reasonable fee, based on administrative costs. Where the data subject submits the application in electronic format and unless the data subject requests another format, the information shall be provided in a commonly used electronic format."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "(4) The right to obtain a copy referred to in paragraph 3 shall be without prejudice to the rights and freedoms of others."
                        ),
                      ]),
                      _vm._m(79),
                      _vm._m(80),
                      _c("p", [
                        _vm._v(
                          "The data subject has the right to obtain from the controller, without undue delay, the rectification of inaccurate personal data concerning him. Taking into account the purposes for which the data were processed, the data subject has the right to obtain the completion of personal data that are incomplete, including by providing an additional statement."
                        ),
                      ]),
                      _vm._m(81),
                      _c("p", [
                        _vm._v(
                          "(1) The data subject has the right to obtain from the controller the deletion of personal data concerning him, without undue delay, and the controller has the obligation to delete personal data without undue delay if one of the following reasons applies:"
                        ),
                      ]),
                      _vm._m(82),
                      _c("p", [
                        _vm._v(
                          "The account will be deleted in maximum 30 days from the request received from the client."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "2. If the controller has made his personal data public and is obliged to delete them pursuant to paragraph (1), the controller shall, taking into account the available technology and the cost of implementation, take reasonable measures, including technical measures, to inform operators who process personal data that the data subject has requested the deletion by these operators of any links to those data or of any copies or reproductions of such personal data."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "3. Paragraphs 1 and 2a shall not apply in so far as processing is necessary:"
                        ),
                      ]),
                      _vm._m(83),
                      _vm._m(84),
                      _c("p", [
                        _vm._v(
                          "(1) The data subject has the right to obtain from the operator the restriction of processing if one of the following cases applies:"
                        ),
                      ]),
                      _vm._m(85),
                      _c("p", [
                        _vm._v(
                          "(2) Where processing has been restricted pursuant to paragraph 1, such personal data may, except in the case of storage, be processed only with the consent of the data subject or for the establishment, exercise or defence of a right in court or for the protection of rights. Another individual or legal entity or for reasons of important public interest of the Union or of a Member State."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "3. A data subject who has obtained a processing restriction pursuant to paragraph 1 shall be informed by the controller before the processing restriction is lifted."
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "To exercise these rights, you can address a written request, dated and signed at the UNTRR registry in Bucharest, str. Ienachita Vacarescu no. 60, 4th district, zip code 040157 or by phone at 0720999216 or by email at protectiadatelor@untrr.ro. You also have the right to go to court."
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("E-ROVINIETA.RO")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("U.N.T.R.R.")]),
      _vm._v(
        " isi asuma dreptul de a modifica aceste prevederi fara o alta notificare."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Termenii si conditiile generale se vor aplica tuturor distribuirilor de roviniete de catre "
      ),
      _c("b", [_vm._v("U.N.T.R.R.")]),
      _vm._v(
        ", prin intermediul site-ului www.e-rovinieta.ro, catre utilizatorul retelei de drumuri nationale, in conditiile prevazute de Normele Metodologice pentru aplicarea de către CNAIR - S.A. a tarifului de utilizare şi a tarifului de trecere."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [
        _vm._v(
          "Nu se pot emite roviniete cu data de valabilitate anterioara datei de emitere."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [
        _vm._v(
          "Nu se pot emite roviniete decat cu cel mult 30 zile anterior datei de inceput a valabilitatii."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [
        _vm._v(
          "Nu se pot emite roviniete in intervalul orar 23:55-00:00 pentru a evita esuarea rovinietei din intarzierea trecerii in a doua zi calendaristice."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [
        _vm._v(
          "DUPA TRIMITEREA UNEI COMENZI NU CIRCULATI PE DRUMURILE NATIONALE INAINTE DE A PRIMI CONFIRMAREA EMITERII ROVINIETEI, PRIN SMS SI/SAU PE E-MAIL!"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("1. Informatii generale")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Proprietarul si administratorul site-ului www.e-rovinieta.ro, denumit in continuare e-rovinieta.ro, este "
      ),
      _c("b", [
        _vm._v("Uniunea Nationala a Transportatorilor Rutieri din Romania"),
      ]),
      _vm._v(" - numita in continuare "),
      _c("b", [_vm._v("U.N.T.R.R.")]),
      _vm._v(
        ", avand Codul Unic de Inregistrare 2836143, distribuitor autorizat de roviniete."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("2. Accesul la informatiile de pe site")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("3. Definitii")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Utilizator")]),
      _vm._v(
        " - persoana fizica sau juridica inscrisa in certificatul de inmatriculare, care are in proprietate sau care, dupa caz, poate folosi in baza unui drept legal vehicule inmatriculate in Romania si "
      ),
      _c("b", [_vm._v("denumit in continuare utilizator roman")]),
      _vm._v(
        ", respectiv persona fizica ori juridica inscrisa in certificatul de inmatriculare, care are in proprietate sau care, dupa caz, poate folosi in baza unui drept legal vehicule inmatriculate in alte state si "
      ),
      _c("b", [_vm._v("denumit in continuare utilizator strain")]),
      _vm._v("."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [
        _vm._v(
          "Distribuitor - Uniunea Nationala a Transportatorilor Rutieri din Romania - U.N.T.R.R."
        ),
      ]),
      _vm._v(
        ", avand sediul in Bucuresti, str.Ienachita Vacarescu, nr. 60, sector 4, Cod Unic de Inregistrare 2836143, persoana juridica agreata de catre Compania Naţională de Administrare a Infrastructurii Rutiere - C.N.A.I.R. S.A ca distribuitor."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Tarif de utilizare")]),
      _vm._v(
        " - o anumita suma a carei plata confera unui vehicul dreptul de a utiliza, pe parcursul unei perioade date, reteaua de drumuri nationale din Romania, concesionată C.N.A.I.R.- S.A.."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Vehicul")]),
      _vm._v(
        " - orice autovehicul rutier înmatriculat, având cel puţin două axe, sau un ansamblu format dintr-un autovehicul şi semiremorca ori remorcile tractate de acesta"
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Vehicul de transport persoane")]),
      _vm._v(
        " - vehiculul conceput şi construit în exclusivitate pentru transportul de pasageri"
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Vehicul de transport marfă")]),
      _vm._v(
        " - vehiculul conceput şi construit pentru transportul de mărfuri ori pentru efectuarea de servicii sau lucrări"
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Vehicul mixt")]),
      _vm._v(
        " - vehicul destinat prin construcţie pentru transportul de persoane şi marfă în compartimente separate"
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Rovinietă")]),
      _vm._v(" - înregistrarea în format electronic a tarifului de utilizare"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Rovinieta valabila")]),
      _vm._v(
        " - reprezintă înregistrarea în baza de date a SIEGMCR a informaţiilor privind achitarea corespunzătoare a tarifului de utilizare pentru un vehicul, a cărei perioadă de valabilitate cuprinde data şi ora pentru care se efectuează verificarea"
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Reteaua de drumuri nationale din Romania")]),
      _vm._v(
        " si drumurile de interes national definite conform art. 6 alin.(1) din O.G. 43/1997 privind regimul drumurilor, republicata, cu modificarile si completarile ulterioare;"
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("4. Documente contractuale")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Comanda")]),
      _vm._v(
        " - document electronic ce intervine ca forma de comunicare intre distribuitor si U.N.T.R.R. si utilizator prin care utilizatorul este de acord sa plateasca si distribuitorul este de acord sa emita documentul care atesta plata utilizarii retelei de drumuri nationale (rovinieta)."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Comanda contine date corecte si complete privind:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _vm._v(
          "vehiculele pentru care se solicita rovinieta (numar de inmatriculare, serie sasiu, nationalitatea vehiculului)"
        ),
      ]),
      _c("li", [
        _vm._v(
          "specificatiile pentru roviniete: tipul, durata valabilitatii si ziua de inceput a perioadei de valabilitate"
        ),
      ]),
      _c("li", [_vm._v("datele clientului necesare pentru facturare")]),
      _c("li", [
        _vm._v(
          "tariful, care include TVA, conform legii in vigoare la data comenzii"
        ),
      ]),
      _c("li", [_vm._v("modalitatea de plata")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("5. Obligatiile distribuitorului")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("6. Modalitati de comunicare a documentelor emise")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("7. Dreptul de autor")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("8. Confidentialitate si Publicitate")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("9. Acceptarea comenzii")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("10. Plata")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("11. Raspundere")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("12. Forta majora")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("13. Litigii si dispozitii finale")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("E-ROVINIETA.RO")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("U.N.T.R.R.")]),
      _vm._v(
        " undertakes the right to modify these provisions without further notice."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [
        _vm._v(
          "No vignettes may be issued with a validity date prior to the date of issue."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [
        _vm._v(
          "Vignettes may not be issued until 30 days prior to the start date of validity."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [
        _vm._v(
          "AFTER SENDING AN ORDER, DO NOT TRAVEL ON THE NATIONAL ROADS BEFORE RECEIVING THE CONFIRMATION OF THE ISSUE OF THE VIGNETTES, BY SMS AND/OR BY E-MAIL!"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("1. General information ")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "The owner and administrator of the website www.e-rovinieta.ro, hereinafter referred to as e-rovinieta.ro, is "
      ),
      _c("b", [
        _vm._v("Uniunea Nationala a Transportatorilor Rutieri din Romania"),
      ]),
      _vm._v(" - hereinafter is "),
      _c("b", [_vm._v("U.N.T.R.R.")]),
      _vm._v(
        ", having the Unique Registration Code 2836143, authorized distributor of vignettes."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("2. Access to information on the website ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("3. Definitions ")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("User")]),
      _vm._v(
        " - individual or legal entity registered in the registration certificate, who owns or who, as the case may be, can use based on a legal right vehicles registered in Romania and hereinafter referred to as Romanian user, respectively individual or legal entity registered in the registration certificate, which owns or which, as the case may be, may use on the basis of a legal right vehicles registered in other states and hereinafter referred to as a foreign user."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("User")]),
      _vm._v(
        " - individual or legal entity registered in the registration certificate, which owns or which, as the case may be, can use based on a legal right vehicles registered in Romania and "
      ),
      _c("b", [_vm._v("hereinafter referred to as Romanian user")]),
      _vm._v(
        ", respectively individual or legal entity registered in the registration certificate, which owns or which, as the case may be, may use on the basis of a legal right vehicles registered in other states and "
      ),
      _c("b", [_vm._v("hereinafter referred to as a foreign user")]),
      _vm._v("."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [
        _vm._v(
          "Distributor - Uniunea Nationala a Transportatorilor Rutieri din Romania - U.N.T.R.R."
        ),
      ]),
      _vm._v(
        ", having its headquarters in Bucharest, str. Ienachita Vacarescu, no. 60, 4th district, Unique Registration Code 2836143, legal entity approved by the National Company for Road Infrastructure Management - C.N.A.I.R. S.A. as a distributor."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Usage tariff")]),
      _vm._v(
        " – a certain amount whose payment confers on a vehicle the right to use, during a given period, the national road network in Romania, granted by C.N.A.I.R.- S.A.. "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Vehicle")]),
      _vm._v(
        " - any registered road vehicle, having at least two axles, or an assembly consisting of a motor vehicle and the semi-trailer or trailers towed by it "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Passenger transport vehicle")]),
      _vm._v(
        " - vehicle designed and constructed exclusively for the transportation of passengers"
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Freight vehicle")]),
      _vm._v(
        " - the vehicle designed and constructed for the transport of goods or for the performance of services or works "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Mixt vehicle")]),
      _vm._v(
        " - vehicle intended by construction for the transport of persons and goods in separate compartments "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Vignette")]),
      _vm._v(" - electronic registration of the usage fee "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Valid vignette")]),
      _vm._v(
        " - represents the registration in the SIEGMCR database of information on the proper payment of the usage fee for a vehicle, the period of validity of which includes the date and time for which the verification is carried out "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Romanian national road network")]),
      _vm._v(
        " and roads of national interest defined according to art. 6 paragraph (1) of Government’s Ordinance 43/1997 regarding the road regime, republished, with the subsequent modifications and completions; "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("4. Contract documents")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Order")]),
      _vm._v(
        " - electronic document that intervenes as a form of communication between the distributor and the U.N.T.R.R. and user through which the user agrees to pay and the distributor agrees to issue the document certifying the payment for the use of the national road network (vignette)."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [
        _vm._v("The order contains correct and complete data regarding:"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _vm._v(
          "vehicles for which the toll is requested (registration number, chassis series, nationality of the vehicle)"
        ),
      ]),
      _c("li", [
        _vm._v(
          "specifications for the vignette: type, shelf life and start day of the shelf life"
        ),
      ]),
      _c("li", [_vm._v("customer data required for invoicing")]),
      _c("li", [
        _vm._v(
          "the tariff, which includes VAT, according to the law in force at the date of the order"
        ),
      ]),
      _c("li", [_vm._v("payment method")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("5. Obligations of the distributor ")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("6. Ways of communicating the issued documents ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("7. Copyright")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("8. Confidentiality and Publicity")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("9. Accepting the order")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("10. Payment")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("11. Liability")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("12. Force majeure")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("13. Litigations and final provisions")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [
        _vm._v(
          "Pursuant to REGULATION (EU) 2016/679 OF THE EUROPEAN PARLIAMENT AND OF THE COUNCIL of 27 April 2016"
        ),
      ]),
      _vm._v(
        " on the protection of individuals with regard to the processing of personal data and on the free movement of such data and repealing Directive 95/46/EC (General Data Protection Regulation):"
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [
        _vm._v(
          "Art. 13: Information to be provided if personal data is collected from the data subject"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v(
          "a) the identity and contact details of the operator and, as the case may be, of his representative;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "b) the contact details of the data protection officer, as the case may be;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) the purposes for which the personal data are processed, as well as the legal basis of the processing;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "d) where the processing is carried out pursuant to Article 6 (1) (f), the legitimate interests pursued by the controller or a third party;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "e) the recipients or categories of recipients of personal data;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "f) where applicable, the intention of the controller to transfer personal data to a third country or international organization and the existence or absence of a Commission decision on the appropriateness or, in the case of transfers referred to in Article 46 or 47 or Article 49 (1), second subparagraph, a reference to the appropriate or appropriate guarantees and the means of obtaining a copy if they have been made available."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v(
          "a) the period for which the personal data will be stored or, if this is not possible, the criteria used to establish this period;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "b) the existence of the right to request from the controller, as regards personal data concerning the data subject, access to them, rectification or deletion thereof or restriction of processing or the right to oppose processing, as well as the right to portability data;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) where the processing is based on Article 6 (1) (a) or Article 9 (2) (a), the existence of the right to withdraw consent at any time, without prejudice to the lawfulness of the processing carried out on the basis of consent before its withdrawal;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "d) the right to lodge a complaint with a supervisory authority;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "e) whether the provision of personal data is a legal or contractual obligation or an obligation necessary to conclude a contract, as well as whether the data subject is obliged to provide such personal data and what are the possible consequences of non-compliance with this obligation;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "f) the existence of an automated decision-making process including profiling, referred to in Article 22 (1) and (4), as well as, at least in those cases, relevant information on the logic used and on the importance and expected consequences of such processing for the data subject."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("table", { staticClass: "table" }, [
      _c("tr", [
        _c("th", { attrs: { width: "20%" } }, [_vm._v("Personal data")]),
        _c("th", { attrs: { width: "*" } }, [_vm._v("Reason")]),
        _c("th", { attrs: { width: "20%" } }, [
          _vm._v("Storage period according to legal provisions"),
        ]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("Surname and name ")]),
        _c("td", [_vm._v("Issuance of invoice")]),
        _c("td", [_vm._v("10 years")]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("Address")]),
        _c("td", [
          _vm._v(
            "Issuance of invoice according to the tax code art. 319 paragraph 20"
          ),
        ]),
        _c("td", [_vm._v("10 years")]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("Telephone")]),
        _c("td", [
          _c("p", [_vm._v("Vignette issue notification (optional)")]),
          _c("p", [_vm._v("Contact if the data is wrong or the order failed")]),
        ]),
        _c("td", [_vm._v("3 years")]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("Email")]),
        _c("td", [
          _c("p", [_vm._v("Confirm account creation")]),
          _c("p", [_vm._v("Send the vignette invoice")]),
          _c("p", [_vm._v("Account deletion notification")]),
        ]),
        _c("td", [_vm._v("3 years")]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("Vehicle data")]),
        _c("td", [_vm._v("Vignette issuance")]),
        _c("td", [_vm._v("10 years")]),
      ]),
      _c("tr", [
        _c("td", [_vm._v("IP Address")]),
        _c("td", [
          _vm._v(
            "Web application logs (this information is required in case of a DDoS attack) or anonymous traffic analysis"
          ),
        ]),
        _c("td", [_vm._v("30 days")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [
        _vm._v(
          "Art. 14: Information to be provided if personal data was not obtained from the data subject "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v(
          "a) the identity and contact details of the operator and, as the case may be, of his representative;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "b) the contact details of the data protection officer, as the case may be;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) the purposes for which the personal data are processed, as well as the legal basis of the processing;"
        ),
      ]),
      _c("li", [_vm._v("d) the categories of personal data concerned;")]),
      _c("li", [
        _vm._v(
          "e) the recipients or categories of recipients of personal data, as the case may be;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "f) where applicable, the intention of the controller to transfer personal data to a recipient in a third country or an international organization and the existence or absence of a Commission decision on the appropriateness or, in the case of transfers referred to in Article 46, or 47 or in the second subparagraph of Article 49 (1), a reference to the appropriate or appropriate guarantees and to the means of obtaining a copy thereof, if they have been made available."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v(
          "a) the period for which the personal data will be stored or, if this is not possible, the criteria used to establish this period;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "b) where the processing is carried out pursuant to Article 6 (1) (f), the legitimate interests pursued by the controller or a third party;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) the existence of the right to request from the controller, as regards personal data concerning the data subject, access to them, their rectification or deletion or restriction of processing and the right to oppose processing, as well as the right to portability data;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "d) where the processing is based on Article 6 (1) (a) or Article 9 (2) (a), the existence of the right to withdraw consent at any time, without prejudice to the lawfulness of the processing carried out on the basis of consent before its withdrawal;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "e) the right to lodge a complaint with a supervisory authority;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "f) the source from which the personal data come and, if applicable, if they come from publicly available sources;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "g) the existence of an automated decision-making process including profiling, referred to in Article 22 (1) and (4), as well as, at least in those cases, relevant information on the logic used and on the importance and expected consequences of such processing for the data subject."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v(
          "a) within a reasonable time after obtaining the personal data, but not more than one month, taking into account the specific circumstances in which the personal data are processed;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "b) if the personal data are to be used for communication with the data subject, at the latest at the time of the first communication to the data subject concerned; or"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) if it is intended to disclose personal data to another recipient, at the latest on the date on which they are first disclosed."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [_vm._v("a) the data subject already has the information;")]),
      _c("li", [
        _vm._v(
          "b) the provision of this information proves to be impossible or would involve disproportionate efforts, especially in the case of processing for archiving purposes in the public interest, for scientific or historical research purposes or for statistical purposes, subject to the conditions and guarantees provided in Article 89 (1), or in so far as the obligation referred to in paragraph 1 of this Article is likely to make it impossible or would seriously affect the achievement of the objectives of such processing, the operator shall take appropriate measures to protect the rights, freedoms and legitimate interests of the data subject, including making the information available to the public;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) the obtaining or disclosure of data is expressly provided for by Union or national law to which the controller is subject and which provides for appropriate measures to protect the legitimate interests of the data subject; or"
        ),
      ]),
      _c("li", [
        _vm._v(
          "d) where personal data must remain confidential under a statutory obligation of professional secrecy governed by Union or national law, including a legal obligation to maintain secrecy."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Art. 15: The right of access of the data subject")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [_vm._v("a) processing purposes;")]),
      _c("li", [_vm._v("b) the categories of personal data concerned;")]),
      _c("li", [
        _vm._v(
          "c) the recipients or categories of recipients to whom personal data have been or are to be disclosed, in particular recipients from third countries or international organizations;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "d) where possible, the period for which personal data are expected to be stored or, if this is not possible, the criteria used to establish this period;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "e) the existence of the right to request the operator to rectify or delete personal data or to restrict the processing of personal data relating to the data subject or the right to oppose the processing;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "f) the right to lodge a complaint with a supervisory authority;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "g) if personal data are not collected from the data subject, any available information on their source;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "h) the existence of an automated decision-making process including profiling, referred to in Article 22 (1) and (4), as well as, at least in those cases, relevant information on the logic used and on the importance and expected consequences of such processing for the data subject."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("Amendment and deletion")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("b", [_vm._v("Art. 16: The right to amend ")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [
        _vm._v(
          'Art. 17: The right to delete data ("the right to be forgotten") '
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v(
          "a) personal data are no longer necessary for the purposes for which they were collected or processed;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "b) the data subject withdraws his or her consent on the basis of which the processing takes place in accordance with Article 6 (1) (a) or Article 9 (2) (a), and there is no other legal basis for processing;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) the data subject opposes the processing pursuant to Article 21 (1) and there are no legitimate reasons prevailing in respect of the processing or the data subject opposes the processing pursuant to Article 21 (2);"
        ),
      ]),
      _c("li", [_vm._v("d) personal data have been illegally processed;")]),
      _c("li", [
        _vm._v(
          "e) personal data must be deleted in order to comply with a legal obligation incumbent on the controller under Union or national law to which the controller is subject;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "f) personal data have been collected in connection with the provision of information society services referred to in Article 8 paragraph (1)."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v(
          "a) for the exercise of the right to free expression and information;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "b) for compliance with a legal obligation which provides for processing under Union or national law applicable to the controller or for the performance of a task performed in the public interest or in the exercise of official authority with which the controller is vested;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) for reasons of public interest in the field of public health, in accordance with Article 9 (2) (h) and (i) and Article 9 (1) (3);"
        ),
      ]),
      _c("li", [
        _vm._v(
          "d) for archiving purposes in the public interest, for scientific or historical research or for statistical purposes, in accordance with Article 89 (1), in so far as the right referred to in paragraph 1 is likely to make it impossible or seriously achieving the objectives of that processing; or"
        ),
      ]),
      _c("li", [
        _vm._v(
          "e) for ascertaining, exercising or defending a right in court."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("b", [_vm._v("Art. 18: The right to restrict processing")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v(
          "a) the data subject disputes the accuracy of the data, for a period which allows the controller to verify the accuracy of the data;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "b) the processing is illegal, and the data subject opposes the deletion of personal data, requesting in return the restriction of their use;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) the controller no longer needs personal data for the purpose of processing, but the data subject requests them for the establishment, exercise or defence of a right in court; or"
        ),
      ]),
      _c("li", [
        _vm._v(
          "d) the data subject has objected to the processing in accordance with Article 21 (1), for the period during which it is verified whether the legitimate rights of the controller prevail over those of the data subject."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }